<template>
  <v-col cols="12" class="pl-0" >
    <span class="txtLabel"> {{ title }}</span>
    <v-row class="pb-0">
      <v-col cols="3">
        <input-cep
          v-model="model.cep"
          label="CEP"
          ref="cep"
          :model-names="modelEndereco"
          :model-endereco="model"
          required
          :disabled="disable"/>
      </v-col>
      <v-col cols="7">
        <input-text
          v-model="model.logradouro"
          label="Endereço"
          required
          :disabled="disable"/>
      </v-col>
      <v-col cols="2">
        <input-number
          v-model="model.nroLogradouro"
          label="Número"
          required
          :disabled="disable"/>
      </v-col>
      <v-col cols="3">
        <input-text
          v-model="model.complemento"
          label="Complemento"
          :disabled="disable"/>
      </v-col>
      <v-col cols="3">
        <input-text
          v-model="model.bairro"
          label="Bairro"
          required
          :disabled="disable"/>
      </v-col>
      <v-col cols="3">
        <input-text
          v-model="model.cidade"
          label="Cidade"
          required
          :disabled="disable"/>
      </v-col>
      <v-col cols="3">
        <input-select
          v-model="model.uf"
          label="Estado"
          :options="$aux.UF"
          item-value="UF"
          item-text="Nome"
          required
          :disabled="disable"/>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
export default {
  props: {
    value: null,
    title: {
      type: String,
      default: 'Endereço'
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modelEndereco: {
        logradouro: 'logradouro',
        bairro: 'bairro',
        uf: 'uf',
        localidade: 'cidade',
      },
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
  },
}
</script>
<style scoped>
  .txtLabel{
    font-weight: 600;
    font-size: 16px;
    margin:0 12px;
  }
</style>
